/* PLP size bar: one size at a time (or "All"), through the theme's existing AJAX filter. */
(function () {
  if (window.__nmsSizeBarInit) return;
  window.__nmsSizeBarInit = true;

  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('[data-size-chip]');
    if (!chip) return;
    e.preventDefault();
    if (chip.classList.contains('is-disabled')) return;

    var container = chip.closest('[data-section-id]');
    var form = container && container.querySelector('collection-filters-form');
    if (!form || typeof form.submitForm !== 'function') {
      window.location.href = chip.getAttribute('href');
      return;
    }

    var isAll = chip.hasAttribute('data-size-all');
    var wasActive = chip.classList.contains('is-active');
    if (isAll && wasActive) return;

    var param = chip.getAttribute('data-param');
    var values = (chip.getAttribute('data-values') || '').split('||').filter(Boolean);

    var url = new URL(window.location.href);
    var sp = url.searchParams;
    sp.delete('page');
    sp.delete(param); // one size at a time: clear any earlier size
    if (!isAll && !wasActive) values.forEach(function (v) { sp.append(param, v); });

    // Same rule as the sidebar: size filter => only in-stock products.
    var hasOther = false;
    sp.forEach(function (_, k) { if (k.indexOf('filter.') === 0 && k !== 'filter.v.availability') hasOther = true; });
    if (hasOther && !sp.has('filter.v.availability')) sp.append('filter.v.availability', '1');

    // instant feedback
    var list = chip.parentNode;
    list.querySelectorAll('[data-size-chip]').forEach(function (c) {
      c.classList.remove('is-active');
      c.setAttribute('aria-pressed', 'false');
    });
    var on = (isAll || wasActive) ? list.querySelector('[data-size-all]') : chip;
    if (on) {
      on.classList.add('is-active');
      on.setAttribute('aria-pressed', 'true');
    }

    window.__nmsNoScroll = true; // keep the size bar in view
    form.submitForm(e, url.pathname + (url.search || ''));
  });
})();
